import { Component, computed, inject, signal } from '@angular/core';
import { StandaloneDefaultImports } from '../standalone-default-imports';
import { AuthUserStateService } from 'src/app/core/state/auth-user-state.service';
import { kendoTooltipsDefaultImports } from '../kendo-default-imports';
import { environment } from 'src/environments/environment';
import { Constants } from 'src/app/core/constants/constants';
import { RoleFilterPipe } from '../../pipes/role-filter.pipe';

@Component({
    selector: 'app-environment-label',
    imports: [StandaloneDefaultImports, kendoTooltipsDefaultImports],
    providers: [RoleFilterPipe],
    template: `
    @if (showLabel()) {
        <div class="environment-label"
            kendoTooltip [tooltipTemplate]="envTag" [position]="'right'" title=" " [callout]="false"
            [class.local]="isLocal()" [class]="environment()">
            <span>{{ environment() }}</span>
        </div>
        <ng-template #envTag>
            <span>Entorno: <b>{{ environmentTooltip() }}</b></span><br>
            <span>Empresa: <b>{{company()}}</b></span><br><br>
            <span>Roles de usuario: <b>{{ userRolesStr() }}</b></span>
        </ng-template>
    }
  `
})
export class EnvironmentLabelComponent {
    // Section: SERVICES
    //----------------------------------------------------------------------
    private readonly authUserState = inject(AuthUserStateService);
    private readonly roleFilterPipe = inject(RoleFilterPipe);

    // Section: SIGNALS, OBSERVABLES AND STATE REACTIVE
    //----------------------------------------------------------------------
    readonly environment = signal<string>(environment.name);
    readonly currentUrl = signal<string>(window.location.href);
    readonly userCompany = this.authUserState.userCompany;
    readonly loggedUser = this.authUserState.user;

    readonly company = computed(() => this.userCompany()?.brand ?? '');

    readonly userRolesStr = computed(() => {
        const roles: string[] = this.loggedUser()?.roles || [];

        if (roles.includes(Constants.USER_ROLES.admin)) {
            return this.roleFilterPipe.transform(Constants.USER_ROLES.admin);
        }

        return roles
            .filter((role) => role !== Constants.USER_ROLES.user)
            .map((role) => this.roleFilterPipe.transform(role))
            .filter(Boolean) // atajo en JavaScript/TypeScript para eliminar todos los valores falsy (null, undefined, false, 0, NaN y cadenas vacías "") de un array.
            .join(', ');
    });

    readonly isLocal = computed(() => this.currentUrl().search('localhost') > -1 || this.currentUrl().search('127.0.0.1') > -1);
    readonly showLabel = computed(() => this.environment() !== 'distribution');
    readonly environmentTooltip = computed(() => {
        const env = this.environment();
        if (env === 'dev') {
            return 'Development' + (this.isLocal() ? ' (Local)' : '');
        } else if (env === 'test') {
            return 'Testing' + (this.isLocal() ? ' (Local)' : '');
        } else if (env === 'dev-ng19') {
            return 'Development Ng19' + (this.isLocal() ? ' (Local)' : '');
        } else if (env === 'local') {
            return 'Local';
        } else {
            return '';
        }
    });
}
